import PropTypes from 'prop-types';
import { useHelmet } from '@thd-nucleus/thd-helmet';
import { extend, useDataModel } from '@thd-nucleus/data-sources';
import { HD_URL } from '../../constants';
import { generateTags } from '../../utils/generate-tags';
import { storeDirectoryByStateModel } from '../../models';
import { generateStateDirectoryDesc, generateStateDirectoryTitle } from './state-directory-helpers';

// --- Tag Handler ---

const storeDirectoryHandler = ({ data, props: { state } }) => {
  const { stateName } = data?.storeDirectoryByState || {};
  const upperState = state.toUpperCase();

  const tags = generateTags({
    canonical: `${HD_URL}/l/${upperState}`,
    description: generateStateDirectoryDesc(stateName),
    ogSiteName: 'The Home Depot',
    title: generateStateDirectoryTitle(stateName)
  });

  return tags;
};

// --- Main Component ---

const StateDirectoryMetadata = ({ state }) => {
  // State is expected to be a two-letter state code (e.g., 'CA' for California).
  const options = {
    variables: {
      state
    }
  };

  const { data } = useDataModel('storeDirectoryByState', options);

  const props = { state };

  useHelmet('stateDirectoryMetadata', { data, props, skipCleanup: true }, storeDirectoryHandler, [state]);
  return null;
};

// --- Component Static Properties (dataModel, propTypes, etc.) ---

StateDirectoryMetadata.displayName = 'StateDirectoryMetadata';

StateDirectoryMetadata.dataModel = extend(storeDirectoryByStateModel);

StateDirectoryMetadata.propTypes = {
  state: PropTypes.string.isRequired
};

export { StateDirectoryMetadata };